import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_spans` layout match on bare `/admin/traces/$traceId`; it renders nothing.
export const Route = createFileRoute('/_app/admin/traces_/$traceId/_spans/')({})
